import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { environment } from 'projects/ebook/src/environments/environment';
import { firstValueFrom } from 'rxjs';
import {
  MessageToLureAction,
  TECH_SUPPORT_CENTER_URL,
  UPUtilityService,
} from 'up';
import { ErrorComponentIconComponent } from '../error-component-icon/error-component-icon.component';

@Component({
  selector: 'ebook-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [ErrorComponentIconComponent, TranslatePipe],
})
export class ErrorComponent implements OnInit {
  private readonly DEFAULT_ERROR_BUTTON = 'GENERIC.EXIT_BUTTON';
  private readonly DEFAULT_ERROR_MESSAGE = 'GENERIC.ERROR.MESSAGE_EBOOK';

  buttonDisabled = signal<boolean>(false);
  buttonTranslationKey = signal<string>(this.DEFAULT_ERROR_BUTTON);
  errorMessageKey = signal<string>(this.DEFAULT_ERROR_MESSAGE);
  errorMessageLinkLabelKey = signal<string>(
    'INSTRUCTOR.PRODUCT_SELECTION.ERROR_LINK_LABEL',
  );
  isErrorWithLink = signal<boolean>(false);
  techSupportUrl = signal<string>(TECH_SUPPORT_CENTER_URL + 'ContactUs');
  unPairBeforeExit = signal<boolean>(false);

  constructor(
    private router: Router,
    private translate: TranslateService,
    private upUtilityService: UPUtilityService,
  ) {
    this.unPairBeforeExit.set(
      this.router.lastSuccessfulNavigation()?.extras.state?.[
        'unPairBeforeExit'
      ] ?? false,
    );
    this.isErrorWithLink.set(
      this.router.lastSuccessfulNavigation()?.extras.state?.[
        'isErrorWithLink'
      ] ?? false,
    );
    this.errorMessageLinkLabelKey.set(
      this.router.lastSuccessfulNavigation()?.extras.state?.[
        'errorMessageLinkLabelKey'
      ] ?? this.DEFAULT_ERROR_MESSAGE,
    );
    this.errorMessageKey.set(
      this.router.lastSuccessfulNavigation()?.extras.state?.['translateKey'] ??
        this.DEFAULT_ERROR_MESSAGE,
    );
    this.buttonTranslationKey.set(
      this.router.lastSuccessfulNavigation()?.extras.state?.[
        'buttonTranslationKey'
      ] ?? this.DEFAULT_ERROR_BUTTON,
    );
  }

  ngOnInit(): void {
    this.setPageTitle();
  }

  async setPageTitle() {
    const translatedPageTitle = await firstValueFrom(
      this.translate.get(['GENERIC.PAGE_TITLE', 'GENERIC.ERROR.PAGE_TITLE']),
    );

    this.upUtilityService.setPageTitle(
      `${translatedPageTitle['GENERIC.ERROR.PAGE_TITLE']} ${translatedPageTitle['GENERIC.PAGE_TITLE']}`,
    );
  }

  onExitClick() {
    this.buttonDisabled.set(true);
    if (this.unPairBeforeExit()) {
      this.upUtilityService.setMessageToLure(
        MessageToLureAction.UNPAIR_SECTION,
      );
      const messageToLure = JSON.parse(
        JSON.parse(
          JSON.stringify(
            this.upUtilityService.getItemFromLocalStorage('messageToLure'),
          ),
        ),
      );
      this.upUtilityService.postMessageToLMS(messageToLure);
      this.upUtilityService.removeItemFromLocalStorage('messageToLure');
    } else {
      this.upUtilityService.returnToCourse(`${environment.apiUrl}/ebook`);
    }
  }
}
